import {
  GetProjectsRequest,
  GetProjectsResponse,
  projectsRestResource,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useGetProjects = () =>
  useRestResourceHook<GetProjectsRequest, GetProjectsResponse>((request) =>
    projectsRestResource.getProjects(request),
  );
